function now() {
    return Date.now();
}

export { now };
